export const convertDate: (date: Date) => string
    = (date: Date): string => {
    let day: number | string = date.getDate();
    let month: number | string = date.getMonth() + 1; // add 1 because months are indexed from 0
    const year = date.getFullYear();
    day = day.toString();
    month = month.toString();
    day.length < 2 && (day = `0${day}`);
    month.length < 2 && (month = `0${month}`);
    return `${year}-${month}-${day}`;
};
